import { QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { RouterProvider } from "@tanstack/react-router";

import en_GB from "antd/es/locale/en_GB";
import zh_CN from "antd/es/locale/zh_CN";

import { appTheme } from "/src/theme/appTheme";
import { router } from "/src/router";
import { queryClient } from "/src/queryClient";
import { StorageKeys, getStorageItem } from "/src/services/storages/StorageKeys";

const langMap = {
  zh: zh_CN,
  en: en_GB,
};

let lang: keyof typeof langMap =
  getStorageItem(StorageKeys.locale)?.startsWith("zh") || navigator?.language?.startsWith("zh")
    ? "zh"
    : "en";
lang = lang.startsWith("zh") ? "zh" : "en";

export function App() {
  console.log(lang);

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={langMap[lang]} theme={appTheme}>
        <RouterProvider router={router} />
      </ConfigProvider>
    </QueryClientProvider>
  );
}
